// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ukhcptlfuyuwaeohgbvu.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVraGNwdGxmdXl1d2Flb2hnYnZ1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzU1NzkxMzIsImV4cCI6MjA1MTE1NTEzMn0.fFJWACRyDEj1Pk5-UROakeWcG0PBSmhQ90B-75aQ_Jk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);